import axios from 'axios';

// helpers
import { getFromLocalStorage, removeAllFromLocalStorage } from '../helpers';

const baseURL = process.env.REACT_APP_BASE_URL;
export const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * handle config for get/post
 */
const handleConfig = (config) => {
  const token = getFromLocalStorage('cfaderToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};

// handle request interceptor
instance.interceptors.request.use(
  (config) => handleConfig(config),
  (error) => Promise.reject(error),
);

// logout on getting status 401 from any api
let loggingOut = false;
const logout = () => {
  // Several requests are in flight at any moment (the profile poll, now-playing,
  // ads). When the session ends they all 401 at once and each one used to fire
  // its own redirect, stacking navigations on top of each other.
  if (loggingOut) return;
  loggingOut = true;
  removeAllFromLocalStorage();
  window.location.replace('/');
};

// handle response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // error.response is undefined for network failures, timeouts and blocked
    // CORS preflights. Reading .status on those threw a TypeError that replaced
    // the real error, and the throw escaped as an unhandled rejection — so a
    // dropped connection surfaced as a mystery instead of a network problem.
    if (!error.response) {
      return Promise.reject({
        status: 0,
        data: { message: error.message || 'Network error. Please check your connection.' },
      });
    }

    if (error.response.status === 401) {
      logout();
      // Still reject: without this the caller's promise never settles, leaving
      // spinners running against a page that is already navigating away.
      return Promise.reject(error.response);
    }

    return Promise.reject(error.response);
  },
);

export default instance;
